import NoticeUnsupportedScreen from './UnsupportedScreen';

export default NoticeUnsupportedScreen;
